import * as React from 'react'
import { Link, Route, RouteComponentProps, Switch } from 'react-router-dom'
import TripFeedbackTabelPane from '../../containers/trip-feedbacks/TripFeedbackTablePane'
import ErrorBoundary from '../ErrorBoundary'
interface IDriverFeedbackPaneProps {
  orgId: string
  routeProps: RouteComponentProps<any>
}

const DriverFeedbackPane = (props: IDriverFeedbackPaneProps): any => {
  return (
    <ErrorBoundary>
      <section>
        <div className='bg-white'>
          <Switch>
            <Route path={props.routeProps.match.path} component={TripFeedbackTabelPane} />
          </Switch>
        </div>
      </section>
    </ErrorBoundary>
  )
}

export default DriverFeedbackPane



// WEBPACK FOOTER //
// ./src/components/trip-feedbacks/TripFeedbackPane.tsx